/*
Sohel 01/07/2023 2698964415 Added Filter Criteria Screen
Sohel 01/09/2023 2699714747 populate Filter Criteria Condition
Sohel 01/09/2023 2698959212 populate filter data conditionally.
Sohel 01/11/2023 2698959212 change filter criteria condition.
dilip 01/12/2023 2698959212 Fixed message and status reset issue.
dilip 01/12/2023 2698959212 Added condition for API call.
sai krishna 01/16/2023 2698959212 add code and description ,type
dilip 01/16/2023 2698959212 Added condition to display Finish button.
Sohel 01/16/2023 2698959212 Fixed Download Configuration Toast issue
Sohel 01/17/2023 2698964415 added Save button
Sohel 01/17/2023 2698964415 fixed page break issue
 dilip 01/20/2023 2698964415 Added Last Step functionality
Sohel 01/17/2023 2698964415 fixed page break issue
Sohel 01/20/2023 2698964415 Added Last Step in Stepper
Sohel 01/22/2023 2698964415 pass Record Group Props
Sohel 01/31/2023 3075154998 payload changes
Ashraf 01/31/2023 2699714747 fixed options issue for sql rules
Sohel 01/31/2023 2698964415 payload changes
Ravi 01/31/2023 2698964415 fixed unsaved popup issue
Ashraf 02/01/2023 2698964415 filtered options for fields
Sohel 02/08/2023 2701335619 Implement Usage Functionality
Sai Maheshwar 02/14/2023 2698964415  fixed field Type issues
Sohel 02/14/2023 2698964415 hide audit fields in Filter Criteria
Dilip 03/21/2023 2698964415 Fixed label changes.
Sohel 03/04/2023 2698964415 allowed function fields in Filter Criteria
Ravi 05/31/2023 2698964415  changed delete popup message
Akhila 06/05/2023 2698964415 unsaved changes bug fix on svae button
Akhila 06/12/2023 2698964415 added role access
Akhila 06/05/2023 2698964415 unsaved changes bug fix on save button
Akhila 06/09/2023 2698964415 unsaved changes bug fix on save button
Ravi 06/23/2023 2698964415 fixed submit issue
//Sohel 10/10/2023 2700912712 Filter Criteria Sql Output Changes
*/
import {
  Typography,
  Button,
  TextField,
  FormHelperText,
  Tooltip,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import React, {useState, useEffect, useContext, useRef} from 'react';
import * as Yup from 'yup';
import {useDispatch, useSelector} from 'react-redux';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import AddIcon from '@material-ui/icons/Add';
import {Field, FieldArray, Form, Formik} from 'formik';
import SqlRuleBuilder from '../../../../../components/SqlRuleBuilder';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import BreadCrums from '../../../../../util/BreadCrum';
import {getOptions} from '../../../../../components/SqlRuleBuilder/utils';
import {
  fetchFilterCriteriaData,
  fetchSelectedProcessorFieldsData,
  postFilterCriteriaData,
  resetFilterCriteriaData,
  resetBasicInfo as resetDownloadConfigurationInfo,
} from '../../../../../redux/reducers/DataManagerRecord';
import PageLoader from '../../../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import {fetchSelectedFieldsData, resetBasicInfo} from '../../../../../redux/reducers/DataManager';
import {resetPrintUsageData} from '../../../../../redux/reducers/printUsage';
import {submissionStart} from '../../../../../redux/reducers/CommonActions/commonActions';

const FilterCriteria = ({
  handleBack,
  handleNext,
  exportManagerRecord,
  setValue,
  isDataManager,
  handleDirty =()=>{},
  managerRecordGroup = false,
  editExisting,
  DataManagerAccess,
  dmTempRecordAccess,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const [deletedRules, setDeletedRules] = useState([]);
  const resultRef = useRef();
  const saveRef = useRef();
  const type = exportManagerRecord ? 'Export' : 'Import';
  const filterCriteriaType = isDataManager ? 'DataManager' : 'Record';
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const {
    addFilterCriteriaStatus,
    filterCriteriaSuccessMsg,
    isFilterCriteriaLoading,
    filterCriteriaErrorMsg,
  } = useSelector(({dataManagerRecord}) => dataManagerRecord);
  const {
    isLoading: printUsageIsLoading,
    successMsg: printUsageSuccessMsg,
    errorMsg: printUsageErrorMsg,
  } = useSelector(({printusage}) => printusage);
  useEffect(() => {
    if (printUsageSuccessMsg || printUsageErrorMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printUsageSuccessMsg, printUsageErrorMsg]);
  const {basicInfoErrorMsg, basicInfoSuccessMsg, isBasicInfoLoading} = useSelector(
    ({dataManagerGroup}) => dataManagerGroup,
  );
  const {
    basicInfoSuccessMsg: successMsg,
    basicInfoErrorMsg: errorMsg,
    isBasicInfoLoading: loading,
  } = useSelector(({dataManagerRecord}) => dataManagerRecord);
  useEffect(() => {
    if (successMsg || errorMsg) {
      setTimeout(() => {
        dispatch(resetDownloadConfigurationInfo());
      }, 1500);
    }
  }, [successMsg, errorMsg]);
  const initialVal = {
    sqlExpression: '',
    formulaExpression: '',
    resultExpCondition: 'AND',
    sqlRules: [],
  };
  // let initialVal = {
  //   sqlExpression: filterRuleGroupData?.sqlExpression ? filterRuleGroupData?.sqlExpression : "",
  //   formulaExpression: filterRuleGroupData?.formulaExpression
  //     ? filterRuleGroupData?.formulaExpression
  //     : "",
  //   resultExpCondition:
  //     filterRuleGroupData?.defaultOperator == null ? "AND" : filterRuleGroupData?.defaultOperator,
  // };
  // const {
  //   addRuleData,
  //   userMetrix,
  //   isLoading,
  //   addRuleGroupStatus,
  //   addRuleStatus,
  //   testFilterResponse,
  //   allFilterCodeAndDisplayName,
  // } = useSelector(({ addRuleGroup }) => addRuleGroup);
  const [isDelete, setIsDelete] = useState(false);
  const currentDeleteIndex = useRef(null);
  const [initialValues, setInitialValues] = useState(initialVal);
  const {
    recordCode,
    selectedProcessorFields,
    filterCriteriaData,
    basicInfoData: infoData,
    dataManagerRecordId,
  } = useSelector(({dataManagerRecord}) => dataManagerRecord);
  const {
    dmCode,
    selectedProcessorFields: dmSelectedProcessorFields,
    basicInfoData,
    dataManagerId,
  } = useSelector(({ dataManagerGroup }) => dataManagerGroup);
  useEffect(() => {
    if (basicInfoSuccessMsg || basicInfoErrorMsg) {
      setTimeout(() => {
        dispatch(resetBasicInfo());
      }, 1500);
    }
  }, [basicInfoErrorMsg, basicInfoSuccessMsg]);
  const arrayHelperRef = useRef();
  const formattedDMRFieldList =
    selectedProcessorFields?.length > 0 &&
    selectedProcessorFields.map((field) => ({
      globalField: field?.fieldName,
      fieldType: field?.dataType ? field?.dataType : 'Text',
      repository: field?.repositoryName,
    }));
  const filtered =
    dmSelectedProcessorFields?.dMRecordEntityList?.length > 0 ?
      dmSelectedProcessorFields?.dMRecordEntityList.filter(
        (field) =>
          (field?.fieldType !== 'Function' ||
              (['NOTE', 'NOTE_TYPE']?.includes(field?.fieldName) &&
                field?.fieldType === 'Function')) &&
            field?.fieldType !== 'Temp Field' &&
            field?.fieldType !== 'Audit Field',
      ) :
      [];
  const formattedDMFieldList =
    filtered?.length > 0 &&
    filtered.map((field) => ({
      fieldName: field?.fieldName,
      fieldType: field?.dataType ? field?.dataType : 'Text',
      repository: field?.repositoryName,
      globalField:
        Object.keys(dmSelectedProcessorFields.columnNameMap).length > 0 ?
          dmSelectedProcessorFields?.columnNameMap[field.repositoryName + '.' + field.fieldName] :
          null,
    }));
  useEffect(() => {
    if (dataManagerRecordId && !isDataManager) {
      dispatch(fetchSelectedProcessorFieldsData(type, dataManagerRecordId, managerRecordGroup));
      dispatch(fetchFilterCriteriaData(dataManagerRecordId, filterCriteriaType));
    }
  }, [dataManagerRecordId]);

  useEffect(() => {
    if (dataManagerId && isDataManager) {
      dispatch(fetchSelectedFieldsData(dataManagerId, type));
      dispatch(fetchFilterCriteriaData(dataManagerId, filterCriteriaType));
    }
  }, [dataManagerId]);

  const validationSchema = Yup.object().shape({
    sqlRules: Yup.array().of(
      Yup.object().shape({
        field: Yup.mixed().required('Field is required'),
        condition: Yup.mixed().required('Condition is required'),
        value: Yup.mixed().when('condition', {
          is: (val) => {
            return !['isNotBlank', 'isBlank'].includes(val?.value);
          },
          then: Yup.mixed().required('Value is required'),
        }),
        value1: Yup.mixed().when('condition', {
          is: (val) => {
            return ['BETWEEN', 'NOT BETWEEN'].includes(val?.value);
          },
          then: Yup.mixed().required('Value is required'),
        }),
      }),
    ),
    sqlExpression: Yup.string().required('Result Expression is required'),
  });

  useEffect(() => {
    if (filterCriteriaData?.code && !isDataManager) {
      const newInitialVal = {
        sqlExpression: filterCriteriaData?.resultExpression ?
          filterCriteriaData?.resultExpression :
          '',
        resultExpCondition:
          filterCriteriaData?.defaultOperator == null ? 'AND' : filterCriteriaData?.defaultOperator,
      };
      const sqlRules =
        filterCriteriaData.dmFilterSqlRuleRequests &&
        filterCriteriaData.dmFilterSqlRuleRequests.map((data) => {
          const selectedFieldList =
            selectedProcessorFields?.length > 0 &&
            selectedProcessorFields.filter(
              (el) => el.fieldName + el.repositoryName === data.field + data.repository,
            )[0];
          const selectedCondition =
            selectedFieldList &&
            getOptions(selectedFieldList.dataType?.toLowerCase()).filter(
              (el) => el.value === data.filterCondition,
            )[0];
          let field;
          if (selectedFieldList) {
            const {
              dataType: fieldType,
              fieldName: globalField,
              repositoryName: repository,
            } = selectedFieldList;
            field = {fieldType, globalField, repository};
          }
          const obj = {
            field: field ? field : null,
            condition: selectedCondition,
            value: data.value ? data.value : '',
            sqlValue: data.sqlExpression,
            value1: data.value1,
            ruleCode: data.ruleCode,
            id: data.filterRuleId,
            createdBy: data.createdBy,
            groupCode: data.groupCode,
          };
          return obj;
        });

      sqlRules.sort((a, b) => {
        if (a.ruleCode < b.ruleCode) {
          return -1;
        }
        if (a.ruleCode > b.ruleCode) {
          return 1;
        }

        // names must be equal
        return 0;
      });

      setInitialValues((prev) => ({...prev, ...newInitialVal, sqlRules: sqlRules}));
    }
  }, [selectedProcessorFields, filterCriteriaData]);
  useEffect(() => {
    if (filterCriteriaData?.code && isDataManager) {
      const newInitialVal = {
        sqlExpression: filterCriteriaData?.resultExpression ?
          filterCriteriaData?.resultExpression :
          '',
        resultExpCondition:
          filterCriteriaData?.defaultOperator == null ? 'AND' : filterCriteriaData?.defaultOperator,
      };
      const sqlRules =
        filterCriteriaData.dmFilterSqlRuleRequests &&
        filterCriteriaData.dmFilterSqlRuleRequests.map((data) => {
          const selectedFieldList =
            dmSelectedProcessorFields?.dMRecordEntityList?.length > 0 &&
            dmSelectedProcessorFields?.dMRecordEntityList?.filter(
              (el) => el.fieldName + el.repositoryName === data.field + data.repository,
            )[0];
          const selectedCondition =
            selectedFieldList &&
            getOptions(selectedFieldList.dataType?.toLowerCase()).filter(
              (el) => el.value === data.filterCondition,
            )[0];
          let field;
          if (selectedFieldList) {
            const globalField =
              Object.keys(dmSelectedProcessorFields.columnNameMap).length > 0 ?
                dmSelectedProcessorFields.columnNameMap[
                  selectedFieldList.repositoryName + '.' + selectedFieldList.fieldName
                ] :
                null;
            const {
              dataType: fieldType,
              repositoryName: repository,
              fieldName: fieldName,
            } = selectedFieldList;
            field = {fieldType, fieldName, globalField, repository};
          }
          const obj = {
            field: field ? field : null,
            condition: selectedCondition,
            value: data.value ? data.value : '',
            sqlValue: data.sqlExpression,
            value1: data.value1,
            ruleCode: data.ruleCode,
            id: data.filterRuleId,
            createdBy: data.createdBy,
            groupCode: data.groupCode,
          };
          return obj;
        });

      sqlRules.sort((a, b) => {
        if (a.ruleCode < b.ruleCode) {
          return -1;
        }
        if (a.ruleCode > b.ruleCode) {
          return 1;
        }

        // names must be equal
        return 0;
      });

      setInitialValues((prev) => ({...prev, ...newInitialVal, sqlRules: sqlRules}));
    }
  }, [dmSelectedProcessorFields, filterCriteriaData]);
  useEffect(() => {
    handleDirty(false, 'reset');
  }, []);
  useEffect(() => {
    if (filterCriteriaSuccessMsg || filterCriteriaErrorMsg) {
      setTimeout(() => {
        if (
          addFilterCriteriaStatus === 200 &&
          filterCriteriaSuccessMsg &&
          isDataManager &&
          !saveRef.current
        ) {
          setValue(0);
        }
        if (
          !isDataManager &&
          addFilterCriteriaStatus === 200 &&
          filterCriteriaSuccessMsg &&
          !saveRef.current
        ) {
          handleNext && handleNext();
        }
        if (dataManagerRecordId && !isDataManager) {
          dispatch(fetchSelectedProcessorFieldsData(type, dataManagerRecordId, managerRecordGroup));
          dispatch(fetchFilterCriteriaData(dataManagerRecordId, filterCriteriaType));
        }
        if (dataManagerId && isDataManager) {
          dispatch(fetchSelectedFieldsData(dataManagerId, type));
          dispatch(fetchFilterCriteriaData(dataManagerId, filterCriteriaType));
        }
        dispatch(resetFilterCriteriaData());
      }, 1500);
    }
  }, [filterCriteriaErrorMsg, filterCriteriaSuccessMsg]);

  const onSubmit = (data) => {
    const code = isDataManager ? dmCode : recordCode;
    if (code) {
      dispatch(submissionStart());
      const conditions =
        data?.sqlRules?.length > 0 ?
          data.sqlRules?.map((item, i) => {
            const {field, condition, ruleCode, sqlValue, value1, value, id} = item;
            return {
              code: code,
              field: field.fieldName,
              filterCondition: condition.value,
              filterRuleId: id ? id : 0,
              repository: field.repository,
              ruleCode: ruleCode,
              sqlExpression: sqlValue,
              value: value,
              value1: value1,
            };
          }) :
          [];
      const payload = {
        code: code,
        dmFilterSqlRuleRequests: conditions,
        deleteIds: deletedRules?.length > 0 ? deletedRules : [],
        resultExpression: data?.sqlExpression ? data?.sqlExpression : '',
        defaultOperator: data.resultExpCondition,
        tabType: filterCriteriaType,
        fileType: type,
        isDraft: 'N',
        lastStep: isDataManager ?
          3 :
          !isDataManager && saveRef.current ?
            basicInfoData?.lastStep :
            4,
        dataManagerId: isDataManager ? dataManagerId : 0,
        dataManagerRecordId:isDataManager ? 0 : dataManagerRecordId
      };
      dispatch(postFilterCriteriaData(payload));
    }
  };
  // const handleTestFormClose = () => {
  //   dispatch(testFilterResetData());
  //   setOpenTestForm(false);
  // };
  const handleDeleteClose = () => {
    setIsDelete(false);
  };
  const handleResultExpression = (arr, setFieldValue, resultExpCondition) => {
    if (!resultRef.current) {
      const result = arr.map((el, i) => el.ruleCode);
      if (result.length > 0 && resultExpCondition) {
        setFieldValue('sqlExpression', result.join(` ${resultExpCondition} `));
      } else {
        setFieldValue('resultExpCondition', 'AND');
        setFieldValue('sqlExpression', '');
      }
    }
  };
  const handleDeleteRule = () => {
    const i = currentDeleteIndex.current;
    const {
      form: {values, setFieldValue},
    } = arrayHelperRef.current;
    const copyArr = [...values.sqlRules];
    const copyDeleteArr = [...deletedRules];

    if (values.sqlRules[i]?.id) {
      copyDeleteArr.push(values.sqlRules[i]?.id);
    }
    copyArr.splice(i, 1);
    setDeletedRules(copyDeleteArr);
    if (arrayHelperRef.current) {
      arrayHelperRef.current.remove(currentDeleteIndex.current);
      handleResultExpression(copyArr, setFieldValue, values.resultExpCondition);
    }
    setIsDelete(false);
  };
  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={onSubmit}
      >
        {(props) => {
          const {
            values,
            setFieldValue: setValueRuleGroup,
            errors,
            handleChange,
            dirty,
          } = props;
          handleDirty && handleDirty(dirty);
          return (
            <>
              <div>
                <BreadCrums
                  name={exportManagerRecord ? 'Export Manager Name' : 'Import Manager Name'}
                  code={basicInfoData?.dmCode || infoData?.recordCode || ''}
                  description={
                    exportManagerRecord ?
                      'Export Manager Description' :
                      'Import Manager Description'
                  }
                  descriptionValue={
                    basicInfoData?.dmDescription || infoData?.recordDescription || ''
                  }
                  returnType={'Type'}
                  returnTypeValue={basicInfoData?.dmType || infoData?.recordType || ''}
                />
              </div>
              <Form noValidate>
                <FieldArray
                  name="sqlRules"
                  render={(arrayHelpers) => {
                    return (
                      <>
                        <div className="table-header new-standard-textfields">
                          <Typography variant="h4"></Typography>

                          <Button
                            variant="outlined"
                            className={`search-btn mx-1 ${classes.buttonRoot}`}
                            onClick={() => {
                              const newRuleCount =
                                values.sqlRules.length > 0 &&
                                Number(
                                  values.sqlRules[values.sqlRules.length - 1].ruleCode.slice(1),
                                ) + 1;
                              const newRuleCode =
                                values.sqlRules.length > 0 ? 'S' + newRuleCount : 'S1';
                              arrayHelpers.push({
                                ruleCode: newRuleCode,
                                field: '',
                                condition: '',
                                value: '',
                                value1: '',
                                sqlValue: '',
                              });
                              if (!resultRef.current && values['resultExpCondition']) {
                                const result = values.sqlRules.map((el, i) => el.ruleCode);
                                result.push(newRuleCode);
                                setValueRuleGroup(
                                  'sqlExpression',
                                  result.join(` ${values['resultExpCondition']} `),
                                );
                              }
                            }}
                          >
                            <AddIcon />
                            Filter Criteria
                          </Button>
                        </div>
                        {values.sqlRules.map((rule, index) => (
                          <>
                            <Field
                              key={index}
                              name={`sqlRules[${index}]`}
                              component={SqlRuleBuilder}
                              index={index}
                              fields={isDataManager ? formattedDMFieldList : formattedDMRFieldList}
                              isDataManager={isDataManager}
                              handleDelete={() => {
                                setIsDelete(true);
                                currentDeleteIndex.current = index;
                                arrayHelperRef.current = arrayHelpers;
                              }}
                            />
                          </>
                        ))}
                      </>
                    );
                  }}
                />

                <RadioGroup
                  aria-label="resultExpCondition"
                  name="resultExpCondition"
                  value={values.resultExpCondition}
                  onChange={(e) => {
                    handleChange(e);
                    const result = values.sqlRules.map((el, i) => el.ruleCode);
                    resultRef.current = false;
                    setValueRuleGroup('sqlExpression', result.join(` ${e.target.value} `));
                  }}
                  style={{
                    display: 'flex',
                    justifyContent: 'start',
                    flexDirection: 'row',
                  }}
                >
                  <FormControlLabel value="AND" control={<Radio color="primary" />} label="AND" />
                  <FormControlLabel value="OR" control={<Radio color="primary" />} label="OR" />
                </RadioGroup>

                <div className="d-flex justify-content-space-between align-items-center mt-1 global-field-textfields new-standard-textfields">
                  <div className="col-11 pl-0 form-group">
                    <TextField
                      className={` ${classes.labelName}`}
                      placeholder="Result Expression"
                      margin="dense"
                      name="sqlExpression"
                      variant="outlined"
                      label="Result Expression"
                      value={values.sqlExpression}
                      required
                      onChange={(e) => {
                        handleChange(e);
                        if (e.target.value.length > 0) {
                          resultRef.current = true;
                          setValueRuleGroup('resultExpCondition', '');
                        }
                      }}
                      // InputLabelProps={{
                      //   shrink: true,
                      // }}
                      fullWidth
                      error={Boolean(errors.sqlExpression)}
                    />
                    <FormHelperText variant="outlined">
                      {errors.sqlExpression ? errors.sqlExpression : ''}
                    </FormHelperText>
                  </div>
                  {/* <Button
                    variant="outlined"
                    className={`ml-auto search-btn ${classes.buttonRoot} mb-4`}
                    onClick={() => {
                      setOpenTestForm(true);
                    }}
                  >
                    Test
                  </Button> */}
                </div>
                <div className="d-flex justify-content-center new-standard-textfields">
                  <Button
                    type="button"
                    onClick={() => {
                      // reset(initialValues);
                      // if (!Object.keys(filterRuleGroupData)?.length) {
                      //   setFormDataFormula([]);
                      //   setFormData([]);
                      // } else {
                      //   setReset(!tableDataReset);
                      // }
                      handleBack();
                    }}
                    variant="outlined"
                    className={`mx-1 reset-btn ${classes.buttonRoot}`}
                  >
                    Back
                  </Button>
                  {/* {(isDraftRecord === "N" || basicInfoData?.isDraft === "N") && ( */}
                  <Button
                    variant="outlined"
                    type="submit"
                    className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                    disabled={
                      editExisting === 'Import' ||
                      (editExisting === 'Export' && !dmTempRecordAccess?.edit) ||
                      (editExisting && !DataManagerAccess?.edit) ||
                      enabledSubmission
                    }
                    onClick={() => {
                      saveRef.current = true;
                      handleDirty(false, 'fixed');
                    }}
                  >
                    Save
                  </Button>
                  {/* )} */}
                  {values.sqlRules.length > 0 ? (
                    <Button
                      type="submit"
                      variant="outlined"
                      className={`mx-1 search-btn ${classes.buttonRoot}`}
                      disabled={
                        editExisting === 'Import' ||
                        (editExisting === 'Export' && !dmTempRecordAccess?.edit) ||
                        (editExisting && !DataManagerAccess?.edit) ||
                        enabledSubmission
                      }
                      onClick={() => {
                        saveRef.current = false;
                        handleDirty(false, 'fixed');
                      }}
                      // disabled={
                      //   !filterRuleRoleAccess?.edit &&
                      //   filterRuleGroupData?.filterSQLRuleResponse?.length > 0 &&
                      //   editExisting
                      // }
                    >
                      {isDataManager ? 'Finish' : 'Save & Next'}
                    </Button>
                  ) : (
                    <Tooltip title="Please add atleast one rule to continue">
                      <span>
                        <Button
                          type="submit"
                          variant="outlined"
                          className={`mx-1 search-btn ${classes.buttonRoot}`}
                          disabled
                        >
                          {isDataManager ? 'Finish' : 'Save & Next'}
                        </Button>
                      </span>
                    </Tooltip>
                  )}
                </div>

                {/*

              <DialogBox
                open={openTestForm}
                dialogClose={handleTestFormClose}
                title={
                  <>
                    <span>
                      <b>{"Run Test For"} :</b>
                    </span>
                    <span className="result-expression">{values?.sqlExpression} </span>
                  </>
                }
                maxWidth="lg"
              >
                <TestComponent passValuesTest={handleTest(values)} />
              </DialogBox> */}
                <DeleteTableRecordPopup
                  open={isDelete}
                  dialogClose={handleDeleteClose}
                  title="Delete Filter Criteria"
                  value={`Are you sure you want to delete the ${
                    values?.sqlRules[currentDeleteIndex.current]?.ruleCode
                  }  Filter Criteria?`}
                  handleSubmit={handleDeleteRule}
                />
              </Form>
            </>
          );
        }}
      </Formik>
      {(isFilterCriteriaLoading || isBasicInfoLoading || loading || printUsageIsLoading) && (
        <PageLoader />
      )}
      {(filterCriteriaErrorMsg || basicInfoErrorMsg || errorMsg || printUsageErrorMsg) && (
        <ErrorSnackbar
          errorMsg={filterCriteriaErrorMsg || basicInfoErrorMsg || errorMsg || printUsageErrorMsg}
        />
      )}
      {(filterCriteriaSuccessMsg || basicInfoSuccessMsg || successMsg || printUsageSuccessMsg) && (
        <SuccessSnackbar
          successMsg={
            filterCriteriaSuccessMsg || basicInfoSuccessMsg || successMsg || printUsageSuccessMsg
          }
        />
      )}
    </>
  );
};
export default FilterCriteria;
